import type { TOC } from '@ember/component/template-only';

interface MarketTotalRevenueCellsThTitleAttributeSignature {
  Args: {
    column: {
      name: string;
    };
  };
}

const MarketTotalRevenueCellsThTitleAttribute = <template>
  <span data-test-id="th-with-tooltip" title={{@column.name}}>
    {{@column.name}}
  </span>
</template> satisfies TOC<MarketTotalRevenueCellsThTitleAttributeSignature>;

export default MarketTotalRevenueCellsThTitleAttribute;
